// Earlier rules mixed lifetime counters with window deltas and treated ICMP
// reachability as application evidence. Preserve readings, not those conclusions.
// Version 2 abstains on every network location; version 3 confirms one only from
// the same interval counted at both ends. Both keep the evidence boundaries this
// console presents, so both are read as recorded.
export const SUPPORTED_METHODS = [2, 3];
const supported = (version) => SUPPORTED_METHODS.includes(version);

const reassessment = {
  segment: "inconclusive",
  confidence: "probable",
  needs_reassessment: true,
  summary: "This record used an older attribution method. Its reported outage location needs reassessment.",
  because: ["The original traffic readings are retained below for investigation."],
  missing: [
    "The older method could confuse lifetime counters, resumed traffic and independent ping results with proof of an outage location.",
    "These readings do not establish which part of the path caused the interruption.",
  ],
};

export function assessedVerdict(verdict) {
  return supported(verdict?.method_version) ? verdict : { ...reassessment };
}

export function assessedSummary(row) {
  return supported(row.method_version) ? row : { ...row, ...reassessment, headline: reassessment.summary };
}

export function assessedEpisode(episode) {
  if (supported(episode.verdict?.method_version)) return episode;
  return { ...episode, original_verdict: episode.verdict, verdict: assessedVerdict(episode.verdict) };
}
